import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const defaultTextColor = "#000"
const defaultFont = "Times New Roman"
const defaultOutline = null

export const useFontSettings = () => {
    const [text, setText] = useState("")
    const [color, setColor] = useState(defaultTextColor)
    const [font, setFont] = useState(defaultFont)
    const [outline, setOutline] = useState(defaultOutline)
    // const [arc, setArc] = useState(0)
    const [size, setSize] = useState(30)
    const [spacing, setSpacing] = useState(30)
    const [rotate, setRotate] = useState(0)
    const [rand, setRand] = useState(1)
    const [scale, setScale] = useState(100)

    const makFabric = useSelector((state: any) => state.makFabric)
    const activeObj = useSelector((state: any) => state.activeObj)

    useEffect(() => {
        if (makFabric && makFabric.getSelectedText() && rand) {
            setText(makFabric.getSelectedText().text)
            setColor(makFabric.getSelectedText().fill)
            setFont(makFabric.getSelectedText().fontFamily)
            setRotate(makFabric.getSelectedText().angle)
            setSize(makFabric.getSelectedText().fontSize)
            setSpacing(makFabric.getSelectedText().charSpacing)
            setOutline(makFabric.getSelectedText().stroke)
            setScale(makFabric.getSelectedText().scaleX * 100)
        }
    }, [makFabric, rand])

    useEffect(() => {
        if (makFabric) {
            makFabric.help.selectedObj = () => setRand(Math.random() * 100)
        }
        return () => { makFabric.help.selectedObj = () => { } }
    }, [makFabric])

    useEffect(() => {
        if (makFabric && rotate) {
            makFabric.getSelectedText() &&
                makFabric.rotateObject(makFabric.getSelectedText(), rotate)
        }
    }, [makFabric, rotate])

    useEffect(() => {
        if (makFabric && size) {
            makFabric.getSelectedText() &&
                makFabric.setFontSize(makFabric.getSelectedText(), size)
        }
    }, [makFabric, size])

    useEffect(() => {
        if (makFabric && spacing) {
            makFabric.getSelectedText() &&
                makFabric.setFontSpacing(makFabric.getSelectedText(), spacing)
        }
    }, [makFabric, spacing])

    const handleAlignText = useCallback((alignment: string) => {
        if (makFabric)
            makFabric.setTextAlign(makFabric.getSelectedText(), alignment)
    }, [makFabric])

    const handleTextChange = (updatedText:string) => {
        if (makFabric && makFabric.getSelectedText()) {
          setText(updatedText)
          makFabric.updateText(makFabric.getSelectedText(), updatedText)
        }
    }

    return {
        text,
        color,
        font,
        outline,
        scale,
        more: {
            rotate,
            spacing,
            size,
            onRotationChanged: setRotate,
            onSpacingChanged: setSpacing,
            onSizeChanged: setSize,
        },
        edit: {
            text,
            handleAlignText,
            handleTextChange
        }
    }

}